import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div`
 
`;

export const AddImovelButton = styled.button`
display:flex ;
align-items: center;
color: ${theme.colors.dark};
&:hover {
  opacity: 0.7;
}

`;